import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiRespondInvitationRequestBody,
  IApiUpdateInvitationResponseBody,
} from '../InvitationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { organizationUsersQueryKeyFactory } from '../../Organizations/hooks/useOrganizationUsersQuery';
import { invitationQueryKeyFactory } from './useInvitationQuery';
import { organizationInvitationsQueryKeyFactory } from './useOrganizationInvitationsQuery';

export type IUseAcceptInvitationMutationValues = {
  organizationId: string;
  invitationId: string;
  body: IApiRespondInvitationRequestBody;
};

export const useAcceptInvitationMutation = (): UseMutationResult<
  IApiUpdateInvitationResponseBody,
  unknown,
  IUseAcceptInvitationMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseAcceptInvitationMutationValues) =>
      api.invitations.accept(values.invitationId, values.body),
    onSuccess: (_, values) =>
      Promise.all(
        [
          { queryKey: organizationInvitationsQueryKeyFactory(values) },
          { queryKey: invitationQueryKeyFactory(values) },
          { queryKey: organizationUsersQueryKeyFactory(values) },
        ].map((filters) => queryClient.invalidateQueries(filters)),
      ),
  });
};
